import { render, staticRenderFns } from "./HeaderGreen.vue?vue&type=template&id=28afa52c&scoped=true&"
import script from "./HeaderGreen.vue?vue&type=script&lang=js&"
export * from "./HeaderGreen.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGreen.vue?vue&type=style&index=0&id=28afa52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afa52c",
  null
  
)

export default component.exports